0
<script setup lang="ts">
/**
 *
 *  Props and emits section
 *
 *
*/

/**
 *
 *  Ref, computed and hooks section
 *
 *
*/
const router = useRouter()
const {
    qTablePaginatorConnector,
    handlePaginate,
    loading
} = usePagination<IBlogCategories>("public/posts/categories", 'GET')
/**
 *
 *  Life cicle events
 *
 *
*/
onMounted(() => {
    handlePaginate()
})
/**
 *
 *  Functions section
 *
 *
*/
function pushParams(c: { id: string, name: string }) {
    router.push({
        query: {
            categories: [c.id]
        },
        replace: true
    })
}

</script>

<template>
    <SkeletonsCard v-if="loading" />
    <q-list padding v-else>
        <div  v-for="c in qTablePaginatorConnector.items" @click="pushParams(c)">
            <q-item-label class="tw-text-customGray-400 tw-text-lg tw-font-medium tw-cursor-pointer">{{ c.name }}</q-item-label>
        </div>
    </q-list>
</template>

<style scoped></style>